import React from "react";
import { useLocation } from "react-router-dom";
import { setScrollHeight } from "../../libraries/ercLibrary";
import { PRODUCT_SKU_PRICE_RESET } from "../../constants/productConstants";
import { useDispatch } from "react-redux";

export default function AddCartButton(props) {
  const dispatch = useDispatch();
  const locationPath = useLocation().pathname;

  // PROPS COMING FROM ProductScreenNew & OrderCartWithVariants
  const {
    cartSkuItems,
    product,
    disableButton,
    addToCartHandler,
    noSkuAlert,
    isThereApendingOrder,
    buttonText,
    setRemoveSummary,
    wholeSaleType,
  } = props;

  return (
    <>
      {!wholeSaleType &&
      cartSkuItems.length === 0 &&
      product.defaultPrice < 100 &&
      product.defaultPrice > 0 &&
      isThereApendingOrder !== "YES" ? (
        <div className="w90p row-center-webkit beddo-border padupsideq">
          <h3>
            Bu ürün sepetteki ilk ürün olamaz. Önce başka bir ürün
            eklemelisiniz.
          </h3>
        </div>
      ) : (
        <button
          className="primary w90p"
          type="button"
          disabled={
            Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
              (a, c) => a + c,
              0
            ) === 0 || disableButton
          }
          onClick={() => {
            addToCartHandler(product._id, product.buyOneGetOneFree);
            setScrollHeight("/urun");
            setRemoveSummary && setRemoveSummary(true);
            locationPath.includes("toptan") &&
              dispatch({ type: PRODUCT_SKU_PRICE_RESET });
          }}
        >
          {buttonText ? buttonText : "Şimdi Sepete Ekle"}
          {buttonText ? (
            ""
          ) : (
            <i className="fal fa-shopping-cart purple bold"></i>
          )}
        </button>
      )}
      {noSkuAlert && (
        <p className="fs1 red-col txtcenter rad2-5r margintop-25 padq lighterredbck">
          {noSkuAlert}
        </p>
      )}
    </>
  );
}
